import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { BaseComponent } from 'src/app/models/base-component';
import { Util } from 'src/app/utils/utils';
import { RolesPartidosService } from '../../services/roles-partidos/roles-partidos.service';
import { GlobalVariable } from 'src/app/global';
import { CampeonatosService } from '../../services/campeonatos/campeonatos.service';
import { ProductosService } from 'src/app/snapquick/services/productos/productos.service';
import {Md5} from 'ts-md5/dist/md5';
import { RegistroJugadorComponent } from '../registro-jugador/registro-jugador.component';

declare const resaltarPestañaMenu:any;

@Component({
    selector: 'app-caja-mesa',
    templateUrl: './caja-mesa.component.html',
    styleUrls: ['./caja-mesa.component.css'],
    standalone: false
})
export class CajaMesaComponent extends BaseComponent implements OnInit {

  cajas:any[]=[];
  nuevo_caja_mesa:any;
  roles_partidos:any[]=[];
  cierre_caja:any;
  campeonatos:any;
  productos:any;
  rol_partido:any;
  fechas_cierre:any[]=[];
  fecha_cierre:string;
  fecha_cierre_texto:string;
  cierre_multiples_fechas:boolean=false;

  modal_registro_caja_mesa:NgbModalRef;
  @ViewChild('modal_registro_caja_mesa')
  private modal_registro_caja_mesa_ref: TemplateRef<any>;

  modal_seleccion_fecha_cierre:NgbModalRef;
  @ViewChild('modal_seleccion_fecha_cierre')
  private modal_seleccion_fecha_cierre_ref: TemplateRef<any>;

  modalJugador:NgbModalRef;

  //lectura de la planilla del partido con la camara del celular
  lectura_planilla:any=null;
  modal_lectura_planilla:NgbModalRef;
  @ViewChild('modal_lectura_planilla')
  private modal_lectura_planilla_ref: TemplateRef<any>;

  constructor(private router: Router,
      public generalService:GeneralService,
      public persistenciaService:PersistenciaService,
      public usuarioService:UsuarioService,
      public modalService: NgbModal,
      private toastr: ToastrService,
      private productosService:ProductosService,
      public campeonatosService:CampeonatosService,
    public rolesPartidosService:RolesPartidosService) {
        super(persistenciaService,modalService,generalService,usuarioService);
      }

  async ngOnInit(): Promise<void> {
    this.init();
    this.buscarAplicacion(this.router.url.substring(1));
    this.configuracion_pagina={};
    let es_usuario_administrador=Util.esUsuarioAdministrador(this.usuario);
    this.filter={
      id_empresa:this.usuario.id_empresa,
      campeonato:GlobalVariable.Dictionary.SELECCION_TODOS,
      campeonatos:[GlobalVariable.Dictionary.SELECCION_TODOS],
      usuarios:[{nombre_usuario:"TODOS",id:0}],
      usuario: {nombre_usuario:"TODOS",id:0},
    }

    if(this.usuario.empresa.usar_control_por_usuarios){
        if(es_usuario_administrador){	
          this.obtenerUsuarios();
        }else{
          this.filter.usuarios=[this.usuario]
          this.filter.usuario=this.usuario;          
        }
    }else{
        this.filter.usuarios=[this.usuario]
        this.filter.usuario=this.usuario;
    }

    this.obtenerCampeonatos();
    this.obtenerProductosEmpresa();
  
      this.column = "updatedAt";
      this.direction = "desc";
      this.getSearch(this.text_search,null);
  }

  ngAfterViewInit() {
        resaltarPestañaMenu(this.router.url.substring(1)+"1");
  }

  async obtenerUsuarios(){
    let usuarios_empresa:any=await this.usuarioService.obtenerUsuariosEmpresa(this.usuario.id_empresa).toPromise();
    this.filter.usuarios=this.filter.usuarios.concat(usuarios_empresa);
  }

  async obtenerCampeonatos(){
    this.filter.campeonatos=[GlobalVariable.Dictionary.SELECCION_TODOS];
    let campeonatos=await this.campeonatosService.obtenerCampeonatosEmpresa(this.usuario.id_empresa).toPromise();
    this.filter.campeonatos=this.filter.campeonatos.concat(campeonatos);
  }

  async obtenerProductosEmpresa(){
    this.productos=await this.productosService.obtenerProductosEmpresa(this.usuario.id_empresa).toPromise();
  }

  getItems(){
		this.blockUI.start('Recuperando... espere por favor!');
		this.rolesPartidosService.obtenerListaRolesPartidos(this).subscribe((dato:any) => {
			this.setPages(dato.paginas);
			this.roles_partidos=dato.roles_partidos;
			for(let i=0;i<this.roles_partidos.length;i++){
				this.roles_partidos[i].fechas_partidos=this.obtenerFechasPartidos(this.roles_partidos[i]);
			}
			this.blockUI.stop();
		});
	}

  //fechas distintas de los partidos que el oficial de mesa tiene asignados en el rol
  obtenerFechasPartidos(rol_partido){
    let partidos=rol_partido.partidos?rol_partido.partidos:[];
    let claves=partidos.map(p => this.claveFecha(p.fecha_hora));
    claves=claves.filter((clave,indice) => clave!=null && claves.indexOf(clave)==indice).sort();
    return claves.map(clave => {
      return {
        fecha:clave,
        fecha_texto:this.etiquetaFecha(clave),
        cantidad_partidos:partidos.filter(p => this.claveFecha(p.fecha_hora)==clave).length
      };
    });
  }

  async abrirCierreCaja(rol_partido){
    if(this.filter.usuario.persona && this.filter.usuario.persona.arbitro){
      this.rol_partido=rol_partido;
      this.blockUI.start();
      let rol_partido_datos:any=await this.rolesPartidosService.obtenerRolPartidoCierres(rol_partido.id).toPromise();
      this.blockUI.stop();
      rol_partido.cierres_caja=rol_partido_datos.cierres_caja?rol_partido_datos.cierres_caja:[];
      this.fechas_cierre=this.obtenerFechasCierre(rol_partido);
      if(this.fechas_cierre.length==0){
        this.toastr.error("¡El oficial de mesa no tiene partidos asignados en este rol!");
      }else if(this.fechas_cierre.length==1){
        await this.modificarRolPartido(rol_partido,this.fechas_cierre[0]);
      }else{
        this.abrirSeleccionFechaCierre();
      }
    }else{
      this.toastr.error("Debe seleccionar un usuario con oficial de mesa asignado!");
    }
  }

  //clave de agrupacion por dia, se usa la fecha local y no la utc porque un partido de la noche cae al dia siguiente en utc
  claveFecha(fecha_hora):string{
    if(!fecha_hora){
      return null;
    }
    let fecha=new Date(fecha_hora);
    return fecha.getFullYear()+"-"+("0"+(fecha.getMonth()+1)).slice(-2)+"-"+("0"+fecha.getDate()).slice(-2);
  }

  //fechas que abarca un cierre, los registrados antes de la separacion por fecha no tienen el campo fecha y pueden agrupar varios dias
  fechasCubiertas(cierre):string[]{
    if(cierre.fecha){
      return [cierre.fecha];
    }
    let claves=(cierre.partidos?cierre.partidos:[]).map(p => this.claveFecha(p.fecha_hora));
    return claves.filter((clave,indice) => clave!=null && claves.indexOf(clave)==indice);
  }

  etiquetaFecha(clave_fecha):string{
    if(!clave_fecha){
      return "";
    }
    let partes=clave_fecha.split("-");
    return partes[2]+"/"+partes[1]+"/"+partes[0];
  }

  //un oficial de mesa puede tener partidos de un mismo rol en dias distintos, cada dia lleva su propio cierre
  obtenerFechasCierre(rol_partido){
    let id_mesa=this.filter.usuario.persona.arbitro.id;
    let partidos_mesa=rol_partido.partidos?rol_partido.partidos:[];
    let cierres_mesa=rol_partido.cierres_caja.filter(c => c.mesa.id==id_mesa);
    let claves=partidos_mesa.map(p => this.claveFecha(p.fecha_hora));
    for(let i=0;i<cierres_mesa.length;i++){
      claves=claves.concat(this.fechasCubiertas(cierres_mesa[i]));
    }
    claves=claves.filter((clave,indice) => clave!=null && claves.indexOf(clave)==indice).sort();
    return claves.map(clave => {
      let cierres_fecha=cierres_mesa.filter(c => this.fechasCubiertas(c).indexOf(clave)>=0);
      let cierre=cierres_fecha.length>0?cierres_fecha[0]:null;
      return {
        fecha:clave,
        fecha_texto:this.etiquetaFecha(clave),
        cantidad_partidos:partidos_mesa.filter(p => this.claveFecha(p.fecha_hora)==clave).length,
        cierre:cierre,
        estado:!cierre?"PENDIENTE":(cierre.procesado?"PROCESADO":"GUARDADO")
      };
    });
  }

  abrirSeleccionFechaCierre(){
    this.modal_seleccion_fecha_cierre=this.modalService.open(this.modal_seleccion_fecha_cierre_ref, {ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static', scrollable:true});
    this.modal_seleccion_fecha_cierre.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  async seleccionarFechaCierre(fecha_cierre){
    this.modal_seleccion_fecha_cierre.close();
    await this.modificarRolPartido(this.rol_partido,fecha_cierre);
  }

  async modificarRolPartido(rol_partido,fecha_cierre){
    this.fecha_cierre=fecha_cierre.fecha;
    this.fecha_cierre_texto=fecha_cierre.fecha_texto;
    this.cierre_multiples_fechas=fecha_cierre.cierre?this.fechasCubiertas(fecha_cierre.cierre).length>1:false;
    if(fecha_cierre.cierre){
      this.cierre_caja=fecha_cierre.cierre;
      await this.reconciliarCierre(rol_partido,this.cierre_caja,fecha_cierre.fecha);
      this.abrirRegistroCajaMesa();
    }else{
      await this.crearNuevoCierre(rol_partido,fecha_cierre.fecha);
    }
  }

  async crearNuevoCierre(rol_partido,fecha){
      this.blockUI.start();
      let mesa=this.filter.usuario.persona.arbitro;
      mesa.persona=JSON.stringify(this.filter.usuario.persona);
      mesa.persona=JSON.parse(mesa.persona);
      this.cierre_caja={
        mesa:mesa,
        fecha:fecha,
        partidos:[],
        pago_arbitro:0,
        pago_mesa:0,
        pago_otros:0,
        total_egresos:0,
        saldo_faltante:0,
        saldo_sobrante:0,
        importe_derecho_cancha:0
      }
      let partidos_fecha=rol_partido.partidos.filter(p => this.claveFecha(p.fecha_hora)==fecha);
      for(let i=0;i<partidos_fecha.length;i++){
        this.cierre_caja.partidos.push(await this.prepararPartidoCierre(rol_partido,partidos_fecha[i].id));
      }
      this.blockUI.stop();
      this.sumarIngresos();
      this.abrirRegistroCajaMesa();
  }

  //el partido completo con lo que necesita el cierre: deudas pendientes de cada equipo y el cobro del derecho de cancha
  async prepararPartidoCierre(rol_partido,id_partido){
      let partido:any=await this.rolesPartidosService.obtenerPartido(id_partido).toPromise();
      partido.w_o_equipo_1={es_wo:false};
      partido.w_o_equipo_2={es_wo:false};
      partido.equipo_1.detalles_ventas_pendientes=await this.rolesPartidosService.obtenerDetallesVentaPendientes(partido.equipo_1.cliente.id).toPromise();
      partido.equipo_2.detalles_ventas_pendientes=await this.rolesPartidosService.obtenerDetallesVentaPendientes(partido.equipo_2.cliente.id).toPromise();
      //el arbitraje depende de la disciplina del partido, y una mesa puede atender varias disciplinas el mismo dia:
      //el importe queda en cada partido. El del cierre se sigue llenando para los cierres que ya existian
      let producto_arbitraje=Util.obtenerProductoArbitraje(rol_partido.campeonato,partido);
      partido.importe_derecho_cancha=(producto_arbitraje?producto_arbitraje.precio_unitario:0)+(partido.escenario.importe_partido/2);
      this.cierre_caja.importe_derecho_cancha=partido.importe_derecho_cancha;
      for(let equipo of [partido.equipo_1,partido.equipo_2]){
        equipo.detalle_pago=[{
                  id:"a"+partido.id+""+equipo.id,
                  producto:producto_arbitraje,
                  precio_unitario:partido.importe_derecho_cancha,
                  importe:partido.importe_derecho_cancha,
                  total:partido.importe_derecho_cancha,
                  qr:0,
                  es_servicio:false,
                  es_combo:false,
                  es_pendiente:false,
                  item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
                  editar_precio:true,
                  cantidad:1,descuento:0,tipo_descuento:false
                }];
      }
      return partido;
  }

  tieneCobros(partido){
    return [partido.equipo_1,partido.equipo_2].some(equipo => (equipo && equipo.detalle_pago?equipo.detalle_pago:[])
      .some(detalle => (Number(detalle.importe)||0)+(Number(detalle.qr)||0)>0));
  }

  //los partidos del cierre se guardan al crearlo y no se volvian a comparar con el rol: un partido reasignado despues a
  //otra mesa u otro dia seguia en el cierre viejo, y uno asignado despues no aparecia. Al abrir un cierre abierto se
  //quitan los que ya no son de la mesa en esa fecha (si no tienen cobros, para no perder dinero registrado) y se
  //agregan los nuevos. Queda guardado asi cuando el usuario guarda el cierre
  async reconciliarCierre(rol_partido,cierre,fecha){
    if(cierre.procesado || !cierre.fecha){
      return;
    }
    let ids_actuales=(rol_partido.partidos?rol_partido.partidos:[]).filter(p => this.claveFecha(p.fecha_hora)==fecha).map(p => String(p.id));
    if(ids_actuales.length==0){
      return;
    }
    let partidos=cierre.partidos?cierre.partidos:[];
    let quitados=partidos.filter(p => ids_actuales.indexOf(String(p.id))<0 && !this.tieneCobros(p));
    cierre.partidos=partidos.filter(p => quitados.indexOf(p)<0);
    let faltantes=ids_actuales.filter(id => !cierre.partidos.some(p => String(p.id)==id));
    if(faltantes.length>0){
      this.blockUI.start();
      for(let i=0;i<faltantes.length;i++){
        cierre.partidos.push(await this.prepararPartidoCierre(rol_partido,faltantes[i]));
      }
      this.blockUI.stop();
    }
    if(quitados.length>0 || faltantes.length>0){
      this.sumarIngresos();
      this.toastr.info("El cierre se actualizó con los partidos asignados a la mesa en esta fecha: "+
        (quitados.length>0?quitados.length+" quitado(s)":"")+(quitados.length>0 && faltantes.length>0?", ":"")+
        (faltantes.length>0?faltantes.length+" agregado(s)":"")+". Guarde el cierre para conservar el cambio.");
    }
  }

  abrirRegistroCajaMesa(){
    this.modal_registro_caja_mesa=this.modalService.open(this.modal_registro_caja_mesa_ref, {windowClass:'rol-partido',ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static', scrollable:true});
    this.modal_registro_caja_mesa.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  agregarPendiente(equipo,detalle_venta){
    if(equipo.detalle_pago.filter(p => p.id==("p"+equipo.id+""+detalle_venta.id)).length>0){
      this.toastr.error("¡El pendiente ya esta incluido!");
    }else{
      let fecha_pendiente=new Date(detalle_venta.venta.fecha);
      equipo.detalle_pago.push({
        id:"p"+equipo.id+""+detalle_venta.id,
        id_venta:detalle_venta.venta.id,
        producto:detalle_venta.producto,
        precio_unitario:detalle_venta.venta.saldo,
        importe:detalle_venta.venta.saldo,
        total:detalle_venta.venta.saldo,
        qr:0,
        es_servicio:false,
        es_combo:false,
        es_pendiente:true,
        item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
        editar_precio:true,
        cantidad:1,descuento:0,tipo_descuento:false,
        descripcion:detalle_venta.descripcion,
        detalle_venta:detalle_venta,
        fecha:fecha_pendiente.getDate()+"/"+(fecha_pendiente.getMonth()+1)+"/"+fecha_pendiente.getFullYear()
      });
      this.sumarIngresos();
    }
  }

  async agregarTarjetaPago(partido,equipo,jugador,tarjeta){
    let tarjeta_producto=this.productos.filter(p => p.nombre.includes(tarjeta));
    tarjeta_producto=tarjeta_producto.length>0?tarjeta_producto[0]:null;
    if(equipo.detalle_pago.filter(p => p.id.includes(tarjeta_producto.id+""+equipo.id+""+jugador.id)).length>0){
      this.toastr.error("¡La tarjeta ya esta incluida para el jugador!");
    }else{
      equipo.detalle_pago.push({
        id:tarjeta_producto.id+""+equipo.id+""+jugador.id,
        jugador:jugador,
        producto:tarjeta_producto,
        descripcion:jugador.persona.nombre_completo,
        precio_unitario:tarjeta_producto.precio_unitario,
        importe:tarjeta_producto.precio_unitario,
        total:tarjeta_producto.precio_unitario,
        qr:0,
        es_servicio:false,
        es_combo:false,
        es_pendiente:false,
        item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
        editar_precio:true,
        cantidad:1,descuento:0,tipo_descuento:false
      });
      this.sumarIngresos();

      if(tarjeta_producto.nombre.includes("AMARILLA")){
        if(partido.equipo_1.id==equipo.id){
          partido.lista_amarillas_equipo_1=partido.lista_amarillas_equipo_1?partido.lista_amarillas_equipo_1:[];
          let jugador_e=partido.lista_amarillas_equipo_1.filter(j => j.id==jugador.id);
          if(jugador_e.length<=0){
            partido.lista_amarillas_equipo_1.push(jugador);
          }
        }else{
          partido.lista_amarillas_equipo_2=partido.lista_amarillas_equipo_2?partido.lista_amarillas_equipo_2:[];
          let jugador_e=partido.lista_amarillas_equipo_2.filter(j => j.id==jugador.id);
          if(jugador_e.length<=0){
            partido.lista_amarillas_equipo_2.push(jugador);
          }
        }
      }else if(tarjeta_producto.nombre.includes("ROJA")){
        if(partido.equipo_1.id==equipo.id){
          partido.lista_rojas_equipo_1=partido.lista_rojas_equipo_1?partido.lista_rojas_equipo_1:[];
          let jugador_e=partido.lista_rojas_equipo_1.filter(j => j.id==jugador.id);
          if(jugador_e.length<=0){
            partido.lista_rojas_equipo_1.push(jugador);
          }
        }else{
          partido.lista_rojas_equipo_2=partido.lista_rojas_equipo_2?partido.lista_rojas_equipo_2:[];
          let jugador_e=partido.lista_rojas_equipo_2.filter(j => j.id==jugador.id);
          if(jugador_e.length<=0){
            partido.lista_rojas_equipo_2.push(jugador);
          }
        }
      }
    }
  }

  async agregarProductoAdicional(equipo,producto_texto){
    let producto=this.productos.filter(p => p.nombre.toUpperCase().includes(producto_texto.toUpperCase()));
    producto=producto.length>0?producto[0]:null;
    if(equipo.detalle_pago.filter(p => p.id.includes(producto.id+""+equipo.id)).length>0){
      this.toastr.error("¡La servicio ya esta incluido!");
    }else{
      equipo.detalle_pago.push({
        id:producto.id+""+equipo.id,
        producto:producto,
        precio_unitario:producto.precio_unitario,
        importe:producto.precio_unitario,
        total:producto.precio_unitario,
        qr:0,
        es_servicio:false,
        es_combo:false,
        es_pendiente:false,
        item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
        editar_precio:true,
        cantidad:1,descuento:0,tipo_descuento:false
      });
      this.sumarIngresos();
    }
  }

  sumarIngresos(){
    this.cierre_caja.total_ingresos_efectivo=0,this.cierre_caja.total_ingresos_qr=0;
    for(let i=0;i<this.cierre_caja.partidos.length;i++){
      for(let j=0;j<this.cierre_caja.partidos[i].equipo_1.detalle_pago.length;j++){
        this.cierre_caja.total_ingresos_efectivo=this.cierre_caja.total_ingresos_efectivo+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].importe;
        this.cierre_caja.total_ingresos_qr=this.cierre_caja.total_ingresos_qr+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].qr;
      }
      for(let j=0;j<this.cierre_caja.partidos[i].equipo_2.detalle_pago.length;j++){
        this.cierre_caja.total_ingresos_efectivo=this.cierre_caja.total_ingresos_efectivo+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].importe;
        this.cierre_caja.total_ingresos_qr=this.cierre_caja.total_ingresos_qr+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].qr;
      }
    }
    this.cierre_caja.saldo_caja=this.cierre_caja.total_ingresos_efectivo-this.cierre_caja.total_egresos+this.cierre_caja.saldo_sobrante-this.cierre_caja.saldo_faltante;
  }

  sumarEgresos(){
    this.cierre_caja.total_egresos=this.cierre_caja.pago_arbitro+this.cierre_caja.pago_mesa+this.cierre_caja.pago_otros;
    this.cierre_caja.saldo_caja=this.cierre_caja.total_ingresos_efectivo-this.cierre_caja.total_egresos+this.cierre_caja.saldo_sobrante-this.cierre_caja.saldo_faltante;
  }

  guardarRolPartidoCierre(){
    if(this.cierre_caja.procesado){
        this.toastr.warning("El cierre de caja ya fue procesado!");
    }else{
      if(this.validarCierreCajaMesa()){
        this.blockUI.start();
        const md5 = new Md5();
        //el identificador incluye mesa y fecha porque una misma mesa puede tener varios cierres en un mismo rol
        this.cierre_caja._id=this.cierre_caja._id?this.cierre_caja._id:md5.appendStr(new Date().toUTCString()+"-"+this.cierre_caja.mesa.id+"-"+this.fecha_cierre).end();
        //un cierre antiguo que agrupa varias fechas se mantiene sin fecha, si se le asignara una las otras fechas quedarian pendientes y se duplicarian sus partidos
        if(!this.cierre_caja.fecha && !this.cierre_multiples_fechas){
          this.cierre_caja.fecha=this.fecha_cierre;
        }
        let rol_partido={
          id:this.rol_partido.id,
          cierre_caja:this.cierre_caja
        }

        this.rolesPartidosService.actualizarCierreCajaRolPartido(rol_partido).subscribe((res:any)=>{
          this.blockUI.stop();
          if(res.tiene_error){
            this.toastr.error(res.mensaje);
          }else{
            this.modal_registro_caja_mesa.close();
            this.toastr.success(res.mensaje);
            this.getItems();
          }
        });
      }
    }
  }

  validarCierreCajaMesa(){
    let res=true;
    for(let i=0;i<this.cierre_caja.partidos.length;i++){
      for(let j=0;j<this.cierre_caja.partidos[i].equipo_1.detalle_pago.length;j++){
        if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].importe==undefined){
          this.toastr.error("Debe especificar el importe en todos los equipos!");
          res=false;
        }
        if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].qr==undefined){
          this.toastr.error("Debe especificar el qr en todos los equipos!");
          res=false;
        }
      }
      for(let j=0;j<this.cierre_caja.partidos[i].equipo_2.detalle_pago.length;j++){
        if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].importe==undefined){
          this.toastr.error("Debe especificar el importe en todos los equipos!");
          res=false;
        }
        if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].qr==undefined){
          this.toastr.error("Debe especificar el qr en todos los equipos!");
          res=false;
        }
      }

      if(this.rol_partido.campeonato.configuracion_pdf_rol_partido.caja_marcador){
        if(!this.cierre_caja.partidos[i].w_o_equipo_1.es_wo && !this.cierre_caja.partidos[i].w_o_equipo_2.es_wo){
          if(this.cierre_caja.partidos[i].marcador_equipo_1 === null){
            this.toastr.error(`Debe ingresar un marcador valido al equipo ${this.cierre_caja.partidos[i].equipo_1.nombre}!`);
            res=false;
          }
          if(this.cierre_caja.partidos[i].marcador_equipo_2 === null){
            this.toastr.error(`Debe ingresar un marcador valido al equipo ${this.cierre_caja.partidos[i].equipo_2.nombre}!`);
            res=false;
          }
          if(this.cierre_caja.partidos[i].marcador_equipo_1 < 0 || this.cierre_caja.partidos[i].marcador_equipo_2 < 0){
            this.toastr.error("No ingresar numeros negativos en los marcadores");
            res=false;
          }

          if(this.cierre_caja.partidos[i].marcador_equipo_1!=this.cierre_caja.partidos[i].equipo_1.total_marcador){
            this.toastr.error("Marcador del equipo: "+this.cierre_caja.partidos[i].equipo_1.nombre+" incorrecto!");
            res=false;
          }
          if(this.cierre_caja.partidos[i].marcador_equipo_2!=this.cierre_caja.partidos[i].equipo_2.total_marcador){
            this.toastr.error("Marcador del equipo: "+this.cierre_caja.partidos[i].equipo_2.nombre+" incorrecto!");
            res=false;
          }
        }
      }
    }
		if(this.cierre_caja.pago_arbitro==undefined){
			this.toastr.error("Debe especificar el pago al arbitro!");
			res=false;
		}
    if(this.cierre_caja.pago_mesa==undefined){
			this.toastr.error("Debe especificar el pago a mesa!");
			res=false;
		}
    if(this.cierre_caja.pago_otros==undefined){
			this.toastr.error("Debe especificar el pago a otros!");
			res=false;
		}
    if(this.cierre_caja.saldo_faltante==undefined){
			this.toastr.error("Debe especificar el saldo faltante!");
			res=false;
		}
    if(this.cierre_caja.saldo_sobrante==undefined){
			this.toastr.error("Debe especificar el saldo sobrante!");
			res=false;
		}
		return res;
  }

  eliminarServicio(partido,equipo,detalle){
    if(equipo.detalle_pago.indexOf(detalle)>0){
      equipo.detalle_pago.splice(equipo.detalle_pago.indexOf(detalle),1);

      if(!detalle.es_pendiente){
        if(detalle.producto.nombre.includes("AMARILLA")){
          if(partido.equipo_1.id==equipo.id){
            let indexJugador = partido.lista_amarillas_equipo_1.findIndex(jugadorLista => jugadorLista.id_persona === detalle.jugador.id_persona);
            partido.lista_amarillas_equipo_1.splice(indexJugador, 1);
          }else{
            let indexJugador = partido.lista_amarillas_equipo_2.findIndex(jugadorLista => jugadorLista.id_persona === detalle.jugador.id_persona);
            partido.lista_amarillas_equipo_2.splice(indexJugador, 1);
          }
        }else if(detalle.producto.nombre.includes("ROJA")){
          if(partido.equipo_1.id==equipo.id){
            let indexJugador = partido.lista_rojas_equipo_1.findIndex(jugadorLista => jugadorLista.id_persona === detalle.jugador.id_persona);
            partido.lista_rojas_equipo_1.splice(indexJugador, 1);
          }else{
            let indexJugador = partido.lista_rojas_equipo_2.findIndex(jugadorLista => jugadorLista.id_persona === detalle.jugador.id_persona);
            partido.lista_rojas_equipo_2.splice(indexJugador, 1);
          }
        }
      }

    }
  }

  generarmensajeWhatsapp(){
    let fecha=new Date();
    let mensaje="📆 "+fecha.toLocaleDateString("es-ES", { weekday: 'long' }).toUpperCase()+", "+fecha.getDate()+" "+fecha.toLocaleString('es-ES', { month: 'long' }).toUpperCase()+" "+fecha.getFullYear()+"\n";
    mensaje=mensaje+"Código de Rol de Partido: "+this.rol_partido.codigo+"\n";

    for(let i=0;i<this.cierre_caja.partidos.length;i++){
      mensaje=mensaje+"\n ✓"+this.cierre_caja.partidos[i].equipo_1.nombre;
      for(let j=0;j<this.cierre_caja.partidos[i].equipo_1.detalle_pago.length;j++){
        if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre.toUpperCase().includes("ARBITRAJE")){
          mensaje=mensaje+"\n    👨🏽‍⚖️ "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre;
        }else if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre.toUpperCase().includes("AMARILLA")){
          mensaje=mensaje+"\n    🟨 "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].descripcion;
        }else if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre.toUpperCase().includes("ROJA")){
          mensaje=mensaje+"\n    🟥 "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].descripcion;
        }else if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre.toUpperCase().includes("SIN BALON")){
          mensaje=mensaje+"\n    ⚽ "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre;
        }else if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre.toUpperCase().includes("SIN CINTILLO")){
          mensaje=mensaje+"\n    🎗️ "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre;
        }else if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre.toUpperCase().includes("PONCHILLOS")){
          mensaje=mensaje+"\n    🎽 "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre;
        }else{
          mensaje=mensaje+"\n    💵 "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre+(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].descripcion?" "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].descripcion:"");
        }
        mensaje=mensaje+(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].fecha?" - "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].fecha:"")+"\n";
        mensaje=mensaje+"      💵 Bs "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].importe;
        mensaje=mensaje+" | 🏁 Bs "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].qr;
      }
      mensaje=mensaje+"\n ✓"+this.cierre_caja.partidos[i].equipo_2.nombre;
      for(let j=0;j<this.cierre_caja.partidos[i].equipo_2.detalle_pago.length;j++){
        if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre.toUpperCase().includes("ARBITRAJE")){
          mensaje=mensaje+"\n    👨🏽‍⚖️ "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre;
        }else if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre.toUpperCase().includes("AMARILLA")){
          mensaje=mensaje+"\n    🟨 "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].descripcion;
        }else if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre.toUpperCase().includes("ROJA")){
          mensaje=mensaje+"\n    🟥 "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].descripcion;
        }else if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre.toUpperCase().includes("SIN BALON")){
          mensaje=mensaje+"\n    ⚽ "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre;
        }else if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre.toUpperCase().includes("SIN CINTILLO")){
          mensaje=mensaje+"\n    🎗️ "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre;
        }else if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre.toUpperCase().includes("PONCHILLOS")){
          mensaje=mensaje+"\n    🎽 "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre;
        }else{
          mensaje=mensaje+"\n    💵 "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre+(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].descripcion?" "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].descripcion:"");
        }
        mensaje=mensaje+(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].fecha?" - "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].fecha:"")+"\n";
        mensaje=mensaje+"      💵 Bs "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].importe;
        mensaje=mensaje+" | 🏁 Bs "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].qr;
      }
    }

    mensaje=mensaje+"\n\n📈 Ingresos: \n 💵 Efectivo Bs "+this.cierre_caja.total_ingresos_efectivo+"\n 🏁 Ingresos QR: Bs "+this.cierre_caja.total_ingresos_qr+"\n\n";
    mensaje=mensaje+"📉 Egresos: \n 🧑🏽‍⚖️ Pago Arbitro Bs "+this.cierre_caja.pago_arbitro+"\n 🧑🏽‍⚖️ Pago Mesa: Bs "+this.cierre_caja.pago_mesa+"\n  💵  Pago Otros: Bs "+this.cierre_caja.pago_otros+"\n\n";
    mensaje=mensaje+"💸 Saldo Faltante: Bs "+this.cierre_caja.saldo_faltante+"\n💸 Saldo Sobrante: Bs "+this.cierre_caja.saldo_sobrante+"\n\n";
    mensaje=mensaje+"💵 *Saldo Final: Bs "+this.cierre_caja.saldo_caja+"*";

    navigator.clipboard.writeText(mensaje);
  }

  //importe de arbitraje del partido; los cierres armados antes del arbitraje por disciplina lo tienen solo en el cierre
  importeArbitraje(partido){
    return partido.importe_derecho_cancha!=null?partido.importe_derecho_cancha:this.cierre_caja.importe_derecho_cancha;
  }

  establecerWOEquipo1(partido){
    if(partido.w_o_equipo_1.es_wo){
      let producto_w_o=this.productos.filter(p => p.nombre.includes("MULTA W.O."))[0];
      partido.equipo_2.detalle_pago[0].producto=producto_w_o;
      partido.equipo_2.detalle_pago[0].descripcion="Partido contra "+partido.equipo_1.nombre;
      partido.equipo_2.detalle_pago[0].precio_unitario=producto_w_o.precio_unitario;
      partido.equipo_2.detalle_pago[0].importe=0;
      partido.equipo_2.detalle_pago[0].total=producto_w_o.precio_unitario;
      partido.equipo_2.detalle_pago[0].qr=0;
      partido.equipo_1.detalle_pago[0].precio_unitario=partido.equipo_1.detalle_pago[0].total*2;
      partido.equipo_1.detalle_pago[0].importe=partido.equipo_1.detalle_pago[0].total*2;
      partido.equipo_1.detalle_pago[0].total=partido.equipo_1.detalle_pago[0].total*2;
      partido.w_o_equipo_2.es_wo=!partido.w_o_equipo_1.es_wo;
      if(partido.disciplina.nombre=="BALONCESTO"){
        partido.marcador_equipo_1=20;
        partido.marcador_equipo_2=0;
      }else{
        partido.marcador_equipo_1=3;
        partido.marcador_equipo_2=0;
      }
    }else{
      partido.equipo_2.detalle_pago[0].producto=Util.obtenerProductoArbitraje(this.rol_partido.campeonato,partido);
      partido.equipo_2.detalle_pago[0].descripcion="";
      partido.equipo_2.detalle_pago[0].precio_unitario=this.importeArbitraje(partido);
      partido.equipo_2.detalle_pago[0].importe=this.importeArbitraje(partido);
      partido.equipo_2.detalle_pago[0].total=this.importeArbitraje(partido);
      partido.equipo_2.detalle_pago[0].qr=0;
      partido.equipo_1.detalle_pago[0].precio_unitario=this.importeArbitraje(partido);
      partido.equipo_1.detalle_pago[0].importe=this.importeArbitraje(partido);
      partido.equipo_1.detalle_pago[0].total=this.importeArbitraje(partido);
    }
  }

  establecerWOEquipo2(partido){
    if(partido.w_o_equipo_2.es_wo){
      let producto_w_o=this.productos.filter(p => p.nombre.includes("MULTA W.O."))[0];
      partido.equipo_1.detalle_pago[0].producto=producto_w_o;
      partido.equipo_1.detalle_pago[0].descripcion="Partido contra "+partido.equipo_2.nombre;
      partido.equipo_1.detalle_pago[0].precio_unitario=producto_w_o.precio_unitario;
      partido.equipo_1.detalle_pago[0].importe=0;
      partido.equipo_1.detalle_pago[0].total=producto_w_o.precio_unitario;
      partido.equipo_1.detalle_pago[0].qr=0;
      partido.equipo_2.detalle_pago[0].precio_unitario=partido.equipo_2.detalle_pago[0].total*2;
      partido.equipo_2.detalle_pago[0].importe=partido.equipo_2.detalle_pago[0].total*2;
      partido.equipo_2.detalle_pago[0].total=partido.equipo_2.detalle_pago[0].total*2;
      partido.w_o_equipo_1.es_wo=!partido.w_o_equipo_2.es_wo;
      if(partido.disciplina.nombre=="BALONCESTO"){
        partido.marcador_equipo_1=0;
        partido.marcador_equipo_2=20;
      }else{
        partido.marcador_equipo_1=0;
        partido.marcador_equipo_2=3;
      }
    }else{
      partido.equipo_1.detalle_pago[0].producto=Util.obtenerProductoArbitraje(this.rol_partido.campeonato,partido);
      partido.equipo_1.detalle_pago[0].descripcion="";
      partido.equipo_1.detalle_pago[0].precio_unitario=this.importeArbitraje(partido);
      partido.equipo_1.detalle_pago[0].importe=this.importeArbitraje(partido);
      partido.equipo_1.detalle_pago[0].total=this.importeArbitraje(partido);
      partido.equipo_1.detalle_pago[0].qr=0;
      partido.equipo_2.detalle_pago[0].precio_unitario=this.importeArbitraje(partido);
      partido.equipo_2.detalle_pago[0].importe=this.importeArbitraje(partido);
      partido.equipo_2.detalle_pago[0].total=this.importeArbitraje(partido);
    }
  }

  async crearNuevoJugador(equipo){
      this.modalJugador = this.modalService.open(RegistroJugadorComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
      this.modalJugador.componentInstance.equipo = equipo;
      this.modalJugador.componentInstance.usuario = this.usuario;
      
      this.modalJugador.componentInstance.alTerminar.subscribe(async (res) => {
        if(res){
          if(res.tiene_error){
            this.toastr.error(res.mensaje);
            this.toastr.error(res.stack.substring(0,500));
          }else{
            this.modalJugador.close();
            this.blockUI.start();
            let jugadores:any=await this.campeonatosService.obtenerListaJugadores(this.usuario.id_empresa,equipo.id).toPromise();
            this.blockUI.stop();
            equipo.jugadores=jugadores;
          }
        }else{
          this.modalJugador.close();
        }
        
      });
    }

  //abre la camara del celular, en escritorio el navegador ignora el capture y muestra el selector de archivos
  tomarFotoPlanilla(){
    this.clickBotonSubir('foto-planilla-camara');
  }

  subirFotoPlanilla(){
    this.clickBotonSubir('foto-planilla-archivo');
  }

  async subirArchivoFotoPlanilla(evento){
    let archivo=evento.target.files && evento.target.files.length>0?evento.target.files[0]:null;
    //se limpia el input para poder volver a elegir la misma foto
    evento.target.value="";
    if(!archivo){
      return;
    }
    if(this.cierre_caja.procesado){
      this.toastr.warning("El cierre de caja ya fue procesado!");
      return;
    }
    if(this.cierre_caja.partidos.length==0){
      this.toastr.error("¡El cierre de caja no tiene partidos!");
      return;
    }
    try{
      this.blockUI.start('Leyendo la planilla... espere por favor!');
      let imagen=await this.leerArchivoComoDataUrl(archivo);
      //la foto del celular llega en varios megas, se reduce antes de enviarla para no saturar la conexion de la cancha
      imagen=await this.redimensionarImagen(imagen,2000);
      let lectura:any=await this.rolesPartidosService.procesarImagenPlanilla({
        inlineData:{data:imagen.split(',')[1],mimeType:'image/jpeg'},
        ids_partidos:this.cierre_caja.partidos.map(p => p.id)
      }).toPromise();
      this.blockUI.stop();
      if(lectura.tiene_error){
        this.toastr.error(lectura.mensaje);
        return;
      }
      this.construirLecturaPlanilla(lectura,imagen);
      this.abrirLecturaPlanilla();
    }catch(e){
      this.blockUI.stop();
      this.toastr.error("¡Ocurrio un error al leer la planilla!");
      console.log(e);
    }
  }

  leerArchivoComoDataUrl(archivo):Promise<string>{
    return new Promise((resolve,reject) => {
      let lector=new FileReader();
      lector.onloadend=() => resolve(lector.result as string);
      lector.onerror=() => reject(lector.error);
      lector.readAsDataURL(archivo);
    });
  }

  redimensionarImagen(imagen_data_url,lado_maximo):Promise<string>{
    return new Promise((resolve) => {
      let imagen=new Image();
      imagen.onload=() => {
        let escala=Math.min(1,lado_maximo/Math.max(imagen.width,imagen.height));
        let lienzo=document.createElement('canvas');
        lienzo.width=Math.round(imagen.width*escala);
        lienzo.height=Math.round(imagen.height*escala);
        lienzo.getContext('2d').drawImage(imagen,0,0,lienzo.width,lienzo.height);
        resolve(lienzo.toDataURL('image/jpeg',0.85));
      };
      imagen.onerror=() => resolve(imagen_data_url);
      imagen.src=imagen_data_url;
    });
  }

  //el servidor devuelve ids, aca se los cambia por los objetos del formulario que ya estan cargados en memoria
  construirLecturaPlanilla(lectura,imagen){
    let partidos_lectura=this.cierre_caja.partidos.filter(p => p.id==lectura.id_partido);
    let partido=partidos_lectura.length>0?partidos_lectura[0]:this.cierre_caja.partidos[0];
    this.lectura_planilla={
      imagen:imagen,
      ver_imagen:false,
      partido:partido,
      //datos impresos en la cabecera de la planilla, sirven para confirmar que es la hoja del partido correcto
      cabecera:[lectura.rol_partido,lectura.categoria,lectura.disciplina,lectura.cancha,lectura.fecha,lectura.hora].filter(d => d).join(" | "),
      advertencias:lectura.advertencias?lectura.advertencias:[],
      equipos:lectura.equipos.map(equipo_lectura => {
        let equipo=partido.equipo_1.id==equipo_lectura.id_equipo?partido.equipo_1:partido.equipo_2;
        return {
          planilla:equipo_lectura.planilla,
          equipo:equipo,
          jugadores:equipo_lectura.jugadores.map(jugador_lectura => {
            return {
              planilla:jugador_lectura.planilla,
              jugador_equipo:this.buscarJugadorEquipo(equipo,jugador_lectura.id_jugador)
            };
          })
        };
      })
    };
    //si el servidor asigno los dos equipos del mismo lado se corrige para que cada planilla apunte a un equipo distinto
    if(this.lectura_planilla.equipos.length==2 && this.lectura_planilla.equipos[0].equipo.id==this.lectura_planilla.equipos[1].equipo.id){
      this.cambiarEquipoLectura(this.lectura_planilla.equipos[0]);
    }
  }

  buscarJugadorEquipo(equipo,id_jugador){
    if(!id_jugador){
      return null;
    }
    let jugadores=(equipo.jugadores?equipo.jugadores:[]).filter(je => je.jugador.id==id_jugador);
    return jugadores.length>0?jugadores[0]:null;
  }

  abrirLecturaPlanilla(){
    this.modal_lectura_planilla=this.modalService.open(this.modal_lectura_planilla_ref, {windowClass:'rol-partido',ariaLabelledBy: 'modal-basic-title',size: 'lg', backdrop: 'static', scrollable:true});
    this.modal_lectura_planilla.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  cambiarPartidoLectura(){
    let partido=this.lectura_planilla.partido;
    for(let i=0;i<this.lectura_planilla.equipos.length;i++){
      this.lectura_planilla.equipos[i].equipo=i==0?partido.equipo_1:partido.equipo_2;
      this.emparejarJugadoresLectura(this.lectura_planilla.equipos[i]);
    }
  }

  //los dos equipos de la planilla siempre son los dos del partido, al cambiar uno el otro toma el contrario
  cambiarEquipoLectura(equipo_lectura){
    let partido=this.lectura_planilla.partido;
    let otros=this.lectura_planilla.equipos.filter(e => e!=equipo_lectura);
    if(otros.length>0){
      otros[0].equipo=partido.equipo_1.id==equipo_lectura.equipo.id?partido.equipo_2:partido.equipo_1;
      this.emparejarJugadoresLectura(otros[0]);
    }
    this.emparejarJugadoresLectura(equipo_lectura);
  }

  emparejarJugadoresLectura(equipo_lectura){
    let asignados=[];
    for(let i=0;i<equipo_lectura.jugadores.length;i++){
      let jugador_equipo=this.emparejarJugadorPlanilla(equipo_lectura.equipo,equipo_lectura.jugadores[i].planilla,asignados);
      equipo_lectura.jugadores[i].jugador_equipo=jugador_equipo;
      if(jugador_equipo){
        asignados.push(jugador_equipo.jugador.id);
      }
    }
  }

  emparejarJugadorPlanilla(equipo,jugador_planilla,asignados){
    let candidatos=(equipo.jugadores?equipo.jugadores:[]).filter(je => asignados.indexOf(je.jugador.id)<0);
    let codigo=this.normalizarTextoPlanilla(jugador_planilla.codigo);
    if(codigo){
      let por_codigo=candidatos.filter(je => this.normalizarTextoPlanilla(je.jugador.codigo)==codigo);
      if(por_codigo.length==1){
        return por_codigo[0];
      }
    }
    let mejor=null,mejor_puntaje=0;
    for(let i=0;i<candidatos.length;i++){
      let puntaje=this.similitudTextoPlanilla(jugador_planilla.nombre,candidatos[i].jugador.persona.nombre_completo);
      if(puntaje>mejor_puntaje){
        mejor_puntaje=puntaje;
        mejor=candidatos[i];
      }
    }
    return mejor_puntaje>=0.5?mejor:null;
  }

  normalizarTextoPlanilla(texto):string{
    if(texto==null){
      return "";
    }
    return (texto+"").toUpperCase().normalize("NFD").replace(new RegExp("[\u0300-\u036f]","g"),"").replace(/[^A-Z0-9 ]/g," ").replace(/\s+/g," ").trim();
  }

  similitudTextoPlanilla(texto_1,texto_2):number{
    let t1=this.normalizarTextoPlanilla(texto_1),t2=this.normalizarTextoPlanilla(texto_2);
    if(!t1 || !t2){
      return 0;
    }
    if(t1==t2){
      return 1;
    }
    if(t1.indexOf(t2)>=0 || t2.indexOf(t1)>=0){
      return 0.85;
    }
    let palabras_1=t1.split(" ").filter(p => p.length>1);
    let palabras_2=t2.split(" ").filter(p => p.length>1);
    if(palabras_1.length==0 || palabras_2.length==0){
      return 0;
    }
    let coincidencias=palabras_1.filter(p => palabras_2.filter(q => q==p || (p.length>3 && q.indexOf(p)==0) || (q.length>3 && p.indexOf(q)==0)).length>0).length;
    return (2*coincidencias)/(palabras_1.length+palabras_2.length);
  }

  obtenerProductoPlanilla(texto){
    let productos=(this.productos?this.productos:[]).filter(p => p.nombre.toUpperCase().includes(texto.toUpperCase()));
    return productos.length>0?productos[0]:null;
  }

  //el pago se agrega una sola vez, los metodos de la pantalla avisan con un error por cada repetido y la lectura carga muchos de golpe
  tieneDetallePago(equipo,clave){
    return equipo.detalle_pago.filter(p => (p.id+"").indexOf(clave)>=0).length>0;
  }

  async aplicarLecturaPlanilla(){
    let partido=this.lectura_planilla.partido;
    let advertencias=[];
    for(let i=0;i<this.lectura_planilla.equipos.length;i++){
      let equipo_lectura=this.lectura_planilla.equipos[i];
      let equipo=equipo_lectura.equipo;

      //la foto define el marcador, se limpia lo anterior para no sumar goles de una lectura previa
      let jugadores_equipo=equipo.jugadores?equipo.jugadores:[];
      for(let j=0;j<jugadores_equipo.length;j++){
        jugadores_equipo[j].jugador.marcador=0;
      }
      for(let j=0;j<equipo_lectura.jugadores.length;j++){
        let jugador_lectura=equipo_lectura.jugadores[j];
        if(!jugador_lectura.jugador_equipo){
          continue;
        }
        let jugador=jugador_lectura.jugador_equipo.jugador;
        jugador.marcador=jugador_lectura.planilla.goles?jugador_lectura.planilla.goles:0;
        if(jugador_lectura.planilla.tarjeta_amarilla){
          await this.agregarTarjetaPlanilla(partido,equipo,jugador,'AMARILLA');
        }
        if(jugador_lectura.planilla.tarjeta_roja){
          await this.agregarTarjetaPlanilla(partido,equipo,jugador,'ROJA');
        }
      }

      this.sumarMarcadorEquipo(equipo);
      let marcador=equipo_lectura.planilla.marcador_final!=null?equipo_lectura.planilla.marcador_final:equipo.total_marcador;
      if(partido.equipo_1.id==equipo.id){
        partido.marcador_equipo_1=marcador;
      }else{
        partido.marcador_equipo_2=marcador;
      }
      if(marcador!=equipo.total_marcador){
        advertencias.push("El marcador de "+equipo.nombre+" ("+marcador+") no coincide con los goles de sus jugadores ("+equipo.total_marcador+").");
      }

      if(equipo_lectura.planilla.cobrar_balon){
        this.agregarProductoPlanilla(equipo,'sin balon');
      }
      if(equipo_lectura.planilla.cobrar_cintillo){
        this.agregarProductoPlanilla(equipo,'sin cintillo');
      }
      if(equipo_lectura.planilla.cobrar_ponchillos){
        this.agregarProductoPlanilla(equipo,'ponchillos');
      }
    }
    this.sumarIngresos();
    this.modal_lectura_planilla.close();
    this.toastr.success("¡Planilla cargada, revise los datos antes de guardar el cierre!");
    for(let i=0;i<advertencias.length;i++){
      this.toastr.warning(advertencias[i]);
    }
  }

  async agregarTarjetaPlanilla(partido,equipo,jugador,tarjeta){
    let producto=this.obtenerProductoPlanilla(tarjeta);
    if(!producto){
      this.toastr.error("¡No existe el producto de tarjeta "+tarjeta+"!");
      return;
    }
    if(!this.tieneDetallePago(equipo,producto.id+""+equipo.id+""+jugador.id)){
      await this.agregarTarjetaPago(partido,equipo,jugador,tarjeta);
    }
  }

  agregarProductoPlanilla(equipo,producto_texto){
    let producto=this.obtenerProductoPlanilla(producto_texto);
    if(!producto){
      this.toastr.error("¡No existe el producto "+producto_texto+"!");
      return;
    }
    if(!this.tieneDetallePago(equipo,producto.id+""+equipo.id)){
      this.agregarProductoAdicional(equipo,producto_texto);
    }
  }

  sumarMarcadorEquipo(equipo){
    equipo.total_marcador=0;
    for(let i=0;i<equipo.jugadores.length;i++){
      equipo.total_marcador=equipo.total_marcador+(equipo.jugadores[i].jugador.marcador==undefined?0:equipo.jugadores[i].jugador.marcador);
    }
    return equipo.total_marcador;
  }

}
